/* eslint-disable no-param-reassign */
/* 楔入动画 */
import { Canvas, dep, DisplayObject, Filter, getDefaults } from '@tencent/alloy-renderer';
import { PresetSubtype } from '@tencent/slide-sdk-model';
import { AnimFilters, Action } from '../../anim-constants';
import { IAnimFilterOptions } from '../../anim-interface';

export default class WedgeFilter extends Filter {
    public static defaults: IAnimFilterOptions = {
        rate: 0,
        direction: PresetSubtype.UnSupport,
        action: Action.ENTR,
    };

    @dep public rate: number;
    @dep public direction = PresetSubtype.UnSupport;
    @dep public action = Action.ENTR;

    public forbidWebgl = true;
    public type = AnimFilters.WEDGE;

    public constructor(options: Partial<IAnimFilterOptions>) {
        super();
        const defaults = getDefaults<typeof WedgeFilter>(this);
        this.rate = options.rate ?? defaults.rate;
        this.direction = options.direction ?? defaults.direction;
        this.action = options.action ?? defaults.action;
    }

    public apply(obj: DisplayObject, canvas: Canvas) {
        const { width, height, bounds } = canvas;
        const { x, y } = bounds;
        const centerX = x + (width / 2);
        const centerY = y + (height / 2);
        const radius = width + height;
        const startAngle = Math.PI * (this.rate - 0.5);
        const  endAngle = Math.PI * (1.5 - this.rate);

        canvas.globalCompositeOperation = this.action === Action.ENTR ? 'destination-out' : 'destination-in';

        canvas.beginPath();
        canvas.moveTo(centerX, centerY);
        canvas.arc(centerX, centerY, radius, startAngle, endAngle);
        canvas.fill();
        canvas.globalCompositeOperation = 'source-over';
    }
}
